import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const documentCategoryService = { getAll, store, show, update, updateStatus, softDelete };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };
    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) params.search_words = searchWords;
    return apiHelper(API_URL).get('/document-categories', { params });
}

function payload(data) {
    return { name: data.name, description: data.description };
}

export function store(data) {
    return apiHelper(API_URL).post('/document-categories', payload(data));
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/document-categories/${uuid}`);
}

export function update(data) {
    return apiHelper(API_URL).put(`/document-categories/${data.uuid}`, payload(data));
}

export function updateStatus(uuid, isActive) {
    return apiHelper(API_URL).patch(`/document-categories/${uuid}`, { is_active: isActive ? 1 : 0 });
}

export function softDelete(uuid) {
    return apiHelper(API_URL).patch(`/document-categories/delete/${uuid}`);
}
